import styled from "styled-components";

const HeaderHistory = () => {
    return (
        <Wrapper>
            <h2>Histórico</h2>
        </Wrapper>
    );
}



const Wrapper = styled.div`
    h2 {
        margin-bottom: 10px;
        color: wheat;
    }
`


export default HeaderHistory;